import React, { useState, useEffect, useRef } from "react";
import { t } from "../../../../utils/i18n";
import { getRequest } from "../../../../utils/httpRequest";
import "./index.scss";
import { IconUserPurple } from "../../../Dashboard/dashboardIcons";

const P2pMini = (props) => {
  const { alt_currency } = props;
  const [offers, setOffers] = useState([]);

  const [search, setSearch] = useState("");
  const [showHam, setShowHam] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(async () => {
    if (!alt_currency) return;
    await getRequest(
      `/landing_page/top_offers?currency=${alt_currency}&offer_type=buy`
    ).then((response) => {
      setOffers((prev) => [...prev, ...response.splice(0, 3)]);
    });
    await getRequest(
      `/landing_page/top_offers?currency=${alt_currency}&offer_type=sell`
    ).then((response) => {
      setOffers((prev) => [...prev, ...response.splice(0, 3)]);
    });
  }, [alt_currency]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowHam(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="p2p-table-container app-card2">
      <div className="table-title">
        <i className="fa fa-dot"></i>
        <div ref={dropdownRef}>
          <div onClick={() => setShowHam(!showHam)}>
            <i className="fa fa-ellipsis-h icon" aria-hidden="true"></i>
          </div>
          {showHam && (
            <ul className="offer-menu-link">
              <li>
                <i className="mr-1 fa fa-plus" />
                <a href="/p2p_trades/offers/new?offer_type=buy">
                  {t("dashboard.p2p.create_buy_offer")}
                </a>
              </li>
              <li>
                <i className="mr-1 fa fa-plus" />
                <a href="/p2p_trades/offers/new?offer_type=sell">
                  {t("dashboard.p2p.create_sell_offer")}
                </a>
              </li>
              <li>
                <i className="mr-1 fa fa-long-arrow-right" />
                <a href="/p2p_trades/offers/search?">{t("dashboard.p2p.see_more")}</a>
              </li>
              <li>
                <i className="mr-1 fa fa-long-arrow-right" />
                <a href="/p2p_trades/offers/my_offers">{t("dashboard.p2p.see_my_offer")}</a>
              </li>
            </ul>
          )}
        </div>
      </div>
      <div className="search">
        <input
          type="text"
          onChange={(e) => setSearch(e.target.value)}
          value={search}
          placeholder={t("dashboard.p2p.search_placeholder")}
          style={{ fontSize: "0.8rem" }}
        />
      </div>
      <table className="table table-bordered rounded-lg">
        <thead className="p2pmini-head">
          <tr className="">
            <th className="">{t("dashboard.p2p.advertiser")}</th>
            <th className="">{t("dashboard.p2p.price", { currency: alt_currency || "..." })}</th>
            <th className="">{t("dashboard.p2p.payment_method")}</th>
            <th className="">{t("dashboard.p2p.action")}</th>
          </tr>
        </thead>
        <tbody className="">
          {offers
            .filter((offer) =>
              Object.values(offer).some(
                (val) =>
                  typeof val === "string" &&
                  val.toLowerCase().includes(search.toLowerCase())
              )
            )
            .map((offer, index) => (
              <tr key={index} className="p2p-table-body-row">
                <td
                  className="p2p-table-datacell d-flex align-items-center"
                  data-label={t("dashboard.p2p.advertiser")}
                >
                  <IconUserPurple className="mr-1" />
                  <span className="offer-label">{offer.customOfferLabel}</span>
                </td>
                <td
                  className="p2p-table-datacell datacell-mobile"
                  data-label={t("dashboard.p2p.price", { currency: alt_currency || "..." })}
                >
                  <span>{Number(offer.tradeRate).toFixed(2) || t("dashboard.common.not_available")}</span>
                </td>
                <td
                  className="p2p-table-datacell datacell-mobile"
                  data-label={t("dashboard.p2p.limit_available")}
                >
                  {offer.paymentOfferLabel}
                </td>
                <td className="p2p-table-datacell" data-label={t("dashboard.p2p.action")}>
                  <a
                    href={`/p2p_trades/offers/trade/${offer.id}/create`}
                    className="btn btn-sm"
                    id={`${
                      offer.flowType === "sell" ? "buy-color" : "sell-color"
                    }`}
                  >
                    {offer.flowType === "sell" ? t("dashboard.p2p.buy") : t("dashboard.p2p.sell")}
                    <i className="fa fa-long-arrow-right ml-1"></i>
                  </a>
                </td>
              </tr>
            ))}
          {offers.length === 0 && (
            <tr>
              <td colSpan="4">
                <div className="text-center">
                  {alt_currency
                    ? t("dashboard.p2p.no_offers_for", { currency: alt_currency })
                    : t("dashboard.p2p.no_offers")}
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default P2pMini;
